/**
 * Normalizes module row fields from API / form (camelCase or PascalCase).
 */

export function getModuleRowId(row) {
  if (!row) {
    return null;
  }
  const v =
    row.id ??
    row.Id ??
    row.ID ??
    row.moduleId ??
    row.ModuleId ??
    row.moduleID ??
    row.ModuleID;
  if (v == null || v === '') {
    return null;
  }
  return v;
}

export function getModuleRowValue(row) {
  if (!row) {
    return null;
  }
  const v = row.value ?? row.Value;
  if (v == null || v === '') {
    return null;
  }
  return v;
}

export function getModuleEnableChat(row) {
  if (!row) {
    return undefined;
  }
  const c = row.enableChat ?? row.EnableChat;
  if (typeof c === 'boolean') {
    return c;
  }
  if (typeof c === 'string') {
    const s = c.trim().toLowerCase();
    if (s === 'true' || s === '1') {
      return true;
    }
    if (s === 'false' || s === '0') {
      return false;
    }
  }
  if (c === 1) {
    return true;
  }
  if (c === 0) {
    return false;
  }
  return undefined;
}
